<template>
  <div class="c-radio">
    <label :for="id" :class="[ radio === value ? 'bold_text' : 'normal_text' ]">{{ label }}</label>
    <input
      type="radio"
      class="radio_type"
      :name="name"
      :id="id"
      v-model="radio"
      :class="{ 'is-checked': radio == value }"
      :value="value"
      :disabled="disabled"
      @click="update"
    />
  </div>
</template>
<script>
export default {
  props: {
    id: {
      type: String,
      default: "",
    },
    config: {
      type: [String, Number, Boolean],
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number, Boolean],
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    config: {
      handler() {
        this.radio = this.config;
      },
      immediate: true,
    },
  },
  data() {
    return {
      radio: "",
    };
  },
  methods: {
    update() {
      this.$emit("update:config", this.value);
      this.$emit("click");
    },
  },
};
</script>
<style lang="scss">
@import "~@/styles/variables.scss";
$checkedCircleTop: ($formLineHeight - $formLabelFontSize)/2 - 1;
.form-oneline .country-group {
  width: auto;
}
.radio_type{
    width: 20px;
    height: 20px;
    appearance: none;
    position: relative;
    float: right;
    margin: 10px;
}
.radio_type:before{
    content: '';
    width: 20px;
    height: 20px;
    border: 1px solid #7d7d7d;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
}
.radio_type:checked:before{
    content: '';
    width: 20px;
    height: 20px;
    border: 1px solid #35e435;
    background:white;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
}
.radio_type:checked:after{
    content: '';
    width: 10px;
    height:5px;
    border: 2px solid #35e435;
    border-top: transparent;
    border-right: transparent;
    text-align: center;
    display: block;
    position: absolute;
    top: 6px;
    left:5px;
    vertical-align: middle;
    transform: rotate(-45deg);
}
.radio_type:checked+label{
    color: #35e435;
}
.normal_text {
    font-weight: normal;
}
.bold_text {
    font-weight: bold;
}
</style>
